import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashCan, faPenToSquare, faPlus } from '@fortawesome/free-solid-svg-icons'
import { faCircleExclamation } from '@fortawesome/pro-light-svg-icons'
/*import { faTrashCan } from '@fortawesome/pro-light-svg-icons'*/
import Question from '../question/Question';
import QuestionHelp from './QuestionHelp';
import ValidationMessage from './ValidationMessage';
import Popup from '../popup/Popup';
import { mandatoryValidation } from '../../functions/Validation';
import { formatAnswer } from '../../functions/FormatAnswer';
import './validation-message.scss';
import CustomDropdown from '../inputs/CustomDropdown';
import Radio from '../inputs/Radio';
import { AnswerType } from '../../enums/AnswerType';

export default function RepeatableChild(props: any) {

    const [question, setQuestion] = useState(props.question);
    const [children, setChildren] = useState(props.question.childInformation);
    const [answer, setAnswer] = useState(props.question.answer);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [tab, setTab] = useState(0);
    const [tabs, setTabs] = useState<number[]>([]);
    const [minimumResponse, setMinimumResponse] = useState(1);
    const [maximumResponse, setMaximumResponse] = useState(100);
    const [title, setTitle] = useState("");
    const [isPOQuestion, setIsPOQuestion] = useState(false);
    const [answerText, setAnswerText] = useState("");

    const childSet = props.question.childInformation.filter((x: { index: number; }) => x.index === 0);

    useEffect(() => {
        setQuestion(props.question);
        if (props.question.answer) {
            setAnswer(props.question.answer);
        }
        const childrenTabs = [...(children.map((x: { index: any; }) => x.index))];
        const distinctChildrenTabs: number[] = [];
        childrenTabs.forEach(tab => {
            if (!distinctChildrenTabs.includes(tab)) {
                distinctChildrenTabs.push(tab);
            }
        })
        setTabs(distinctChildrenTabs);
        setTab(Math.max.apply(null, distinctChildrenTabs));

        let updatedChildren = children.map((childQuestion: any) => {
            childQuestion.visible = true;
            childQuestion.questionSetQuestion.visible = true;
            childQuestion.page = question.page;
            if (childQuestion.index > 0 && childQuestion.sectionName != "Occupancy Details") {
                childQuestion.questionSetQuestion.enabled = true;
            }
            return childQuestion;
        });
        setChildren(updatedChildren);

        if (question.questionSetAnswerType.answerTypeName === "Boolean" && (props.question.questionSetQuestion.childQuestionRepeatMinimum != null && props.question.questionSetQuestion.childQuestionRepeatMinimum !== 0)) {
            setMinimumResponse(props.question.questionSetQuestion.childQuestionRepeatMinimum);
        }

        if (question.questionSetAnswerType.answerTypeName === "Boolean" && (props.question.questionSetQuestion.childQuestionRepeatMaximum != null && props.question.questionSetQuestion.childQuestionRepeatMaximum !== 0)) {
            setMaximumResponse(props.question.questionSetQuestion.childQuestionRepeatMaximum);
        }

        setTitle(props.question.repeatableLabel);

        if (question.questionSetQuestion.text.toLowerCase().includes("is the building currently fully occupied?")) {
            setIsPOQuestion(true);
            setMinimumResponse(1);
        }

    }, [])

    useEffect(() => {
        question.answer = answer;
        let answerText = question.answerList?.find((x: any) => x.value === answer)?.text ?? question.answer;
        setAnswerText(answerText);

        updateChildren()
        let updatedQuestion = question;
        props.showConditionQuestions(question.questionSetQuestion.questionID, answer);

        if (question.questionSetAnswerType.answerTypeName === "ListValueID"
            || question.questionSetAnswerType.answerTypeName === "RadioSelect") {
            setMinimumResponse(parseInt(answerText));

            updatedQuestion.questionSetQuestion.childQuestionRepeatMinimum = parseInt(answerText);

            if (answerText.includes("+")) {
                setMaximumResponse(100);
                updatedQuestion.questionSetQuestion.childQuestionRepeatMaximum = 100;
            } else {
                setMaximumResponse(parseInt(answerText));
                updatedQuestion.questionSetQuestion.childQuestionRepeatMaximum = parseInt(answerText);
            }

            validateItemsAdded();
        } else {
            if (answer === "1") {
                updatedQuestion.questionSetQuestion.childQuestionRepeatMinimum = 1;
            } else {
                if (question.questionSetQuestion.text.toLowerCase().includes("is the building currently fully occupied?")) {
                    updatedQuestion.questionSetQuestion.childQuestionRepeatMinimum = 1;
                } else {
                    updatedQuestion.questionSetQuestion.childQuestionRepeatMinimum = 0;
                }
            }

        }

        setQuestion(updatedQuestion);

    }, [answer]);

    useEffect(() => {
        if (question.questionSetAnswerType.answerTypeName === "ListValueID") {
            validateItemsAdded();
        }
    }, [maximumResponse]);

    const updateRadioAnswer = (answer: string) => {
        setAnswer(answer);
        question.validationFail = false;
        setQuestion(question);
    }

    const updateDropdownAnswer = (answer: string) => {
        setAnswer(answer);
    };

    function disableScrolling() {
        var x = window.scrollX;
        var y = window.scrollY;
        window.onscroll = function () { window.scrollTo(x, y); };
    }

    function enableScrolling() {
        window.onscroll = function () { };
    }

    const togglePopup = () => {
        if (!isPopupOpen) {
            disableScrolling();
        } else {
            enableScrolling();
        }

        setIsPopupOpen(!isPopupOpen);
    }

    const updateChildren = () => {
        if ((parseInt(answer) === 0 && !question.questionSetQuestion.text.toLowerCase().includes("is the building currently fully occupied?")) || answer === "") {
            let updatedQuestionChildren = question.childInformation.filter((x: { index: number; }) => x.index === 0);
            let updatedQuestion = question;
            updatedQuestion.childInformation = updatedQuestionChildren;
            setQuestion(updatedQuestion);
            setTab(0);
            setTabs([0]);
            setChildren(updatedQuestion.childInformation);
        } else {
            setChildren([...question.childInformation]);
        }
    }

    const setNewChild = () => {
        let newtab = 1;
        if (tabs.length > 0) {
            newtab = Math.max.apply(null, tabs) + 1
        }
        setTab(newtab);
        var currentChildren: any = [...children];
        let alreadyExists = currentChildren.some((x: { index: number; }) => x.index === newtab);
        if (!alreadyExists) {
            let firstChild = structuredClone(childSet);
            firstChild.map((childQuestion: {
                questionSetQuestion: any; index: number;
            }) => {
                childQuestion.index = newtab;
                childQuestion.questionSetQuestion.enabled = true;
                currentChildren = [...currentChildren, childQuestion];
                return childQuestion;
            });
            question.childInformation = currentChildren;
        }
        let tabsList = tabs;
        if (!tabsList.includes(newtab)) {
            tabsList.push(newtab);
            setTabs(tabsList);
        }

        setQuestion(question);
        updateChildren();
        togglePopup();
    }

    const addChildQuestion = () => {
        let childFormValid = true;
        let newQuestion = question;
        var updatedChildQuestions = newQuestion.childInformation.map((childQuestion: any) => {
            if (childQuestion.index === tab) {
                //if the question has already failed another validation then set the formValid to false
                if (childQuestion.validationFail) {
                    childFormValid = false;
                } else {
                    if (mandatoryValidation(childQuestion)) {
                        childQuestion.validationFail = false;
                    } else {
                        childFormValid = false;
                        childQuestion.validationFail = true;
                    }
                }
            }
            return childQuestion;
        });
        newQuestion.childInformation = updatedChildQuestions;
        newQuestion.validationFail = false;
        setQuestion(newQuestion);
        updateChildren();
        if (childFormValid) {
            togglePopup();
        }
    }

    const deleteChildResponse = (tabnumber: number, closePopup: boolean) => {
        var newChildren: any = [];

        children.forEach((child: any) => {
            if (child.index < tabnumber) {
                newChildren = [...newChildren, child];
            }
            if (child.index > tabnumber) {
                child.index = child.index - 1;
                newChildren = [...newChildren, child];
            }
        });

        let tabsList = tabs;
        tabsList.pop();

        let newQuestion = question;

        newQuestion.childInformation = newChildren;
        if (question.questionSetQuestion.text !== "") {
            newQuestion.validationFail = Math.max.apply(null, tabsList) > parseInt(question.answer);
        }

        setQuestion(newQuestion);
        setTabs([...tabsList]);
        setTab(Math.max.apply(null, tabsList))
        if (closePopup) {
            togglePopup();
        }
        updateChildren();
    }

    const getPopupContent = (childTab: number) => {
        return ((<>
            <h1>{title} #{childTab}</h1>
            {
                children.map((childQuestion: any, index: any) => {
                    if (childQuestion.index === childTab) {
                        return <Question question={childQuestion} key={childQuestion.questionSetQuestion.questionID + "_" + childQuestion.index} showConditionQuestions={props.showConditionQuestions} enableQuestions={props.enableQuestions} page={props.page} setIndividualCustomerDetails={props.setIndividualCustomerDetails} showConditionalChildren={props.showConditionalChildren} resetRelatedQuestionsValidationOnAnswerChange={props.resetRelatedQuestionsValidationOnAnswerChange} questionIdPosition={props.questionIdPosition + "|" + childQuestion.questionSetQuestion.questionID + "-" + childQuestion.index} resetCoverValidation={props.resetCoverValidation} />
                    } else {
                        return <span key={childQuestion.questionSetQuestion.questionID + "_" + childQuestion.index}></span>;
                    }
                }
                )
            }
            <button className="add-new-child-response" onClick={() => addChildQuestion()}>Save</button>
            <button className="delete-child-response" onClick={() => deleteChildResponse(childTab, true)}>Delete</button>
        </>))
    }

    const tabSummary = (summarytab: number) => {
        let groupResponses = children.filter((x: {
            questionSetQuestion: any; index: number;
        }) => x.index === summarytab && x.questionSetQuestion.visible && x.questionSetQuestion.enabled);
        let groupResponsesLength = groupResponses.length - 1;

        if (!groupResponses.some((x: {
            index: number; answer: string; questionSetQuestion: { mandatory: boolean; };
        }) => x.answer === "" && x.questionSetQuestion.mandatory)) {

            return (<><div className="repeatable-response-group">
                <span className="repeatable-summary-title">{title} #{summarytab}</span>
                <span className="repeatable-summary-actions">
                    <span className="repeatable-summary-icon"><FontAwesomeIcon icon={faPenToSquare} onClick={() => editChildResponse(summarytab)} /></span>
                    <span className="repeatable-summary-icon bin"><FontAwesomeIcon icon={faTrashCan} onClick={() => deleteChildResponse(summarytab, false)} /></span>
                </span>
                <div className="repeatable-summary-container">
                    <span className="repeatable-summary">
                        {groupResponses.map((response: any, index: any) => {
                            return (<span key={"groupresponse_" + index}>{formatAnswer(response)}
                                {index < groupResponsesLength &&
                                    <span className="child-response-separator"> | </span>}
                            </span>)
                        })}
                    </span>
                </div>
            </div>
            </>)

        } else {
            return (<></>)
        }
    }

    const editChildResponse = (tabnumber: number) => {
        setTab(tabnumber);
        togglePopup();
    }

    const validateItemsAdded = () => {
        let updatedQuestion = question;
        updatedQuestion.validationFail = tab > parseInt(answerText);
        setQuestion(updatedQuestion);
    }

    return (
        <>
            <div>
                {question.questionSetAnswerType.answerTypeName === "Boolean" && question.questionSetQuestion.text !== "" &&
                    <Radio question={props.question} key={props.question.questionSetQuestion.questionID + "_" + props.question.index} showConditionQuestions={props.showConditionQuestions} enableQuestions={props.enableQuestions} page={props.page} showConditionalChildren={props.showConditionalChildren} questionIdPosition={props.questionIdPosition} isRepeatable={true} updateRepeatableAnswer={updateRadioAnswer} resetCoverValidation={props.resetCoverValidation} />
                }

                {question.questionSetAnswerType.answerTypeName === "ListValueID" &&
                    <CustomDropdown question={props.question} key={props.question.questionSetQuestion.questionID + "_" + props.question.index} showConditionQuestions={props.showConditionQuestions} enableQuestions={props.enableQuestions} page={props.page} setIndividualCustomerDetails={props.setIndividualCustomerDetails} showConditionalChildren={props.showConditionalChildren} questionIdPosition={props.questionIdPosition} isRepeatable={true} updateRepeatableAnswer={updateDropdownAnswer} resetRelatedQuestionsValidationOnAnswerChange={props.resetRelatedQuestionsValidationOnAnswerChange} resetCoverValidation={props.resetCoverValidation} />
                }
                {question.questionSetAnswerType.answerTypeName === "RadioSelect" &&
                    <Radio question={props.question} key={props.question.questionSetQuestion.questionID + "_" + props.question.index} showConditionQuestions={props.showConditionQuestions} enableQuestions={props.enableQuestions} page={props.page} setIndividualCustomerDetails={props.setIndividualCustomerDetails} showConditionalChildren={props.showConditionalChildren} questionIdPosition={props.questionIdPosition} isRepeatable={true} updateRepeatableAnswer={updateDropdownAnswer} resetRelatedQuestionsValidationOnAnswerChange={props.resetRelatedQuestionsValidationOnAnswerChange} resetCoverValidation={props.resetCoverValidation} options={props.question?.answerList ?? []} />
                }


            </div>
            {(parseInt(answerText) > 0 || isPOQuestion) && answer !== "" &&
                <>
                    {tabs.map((tab: any) => {
                        if (tab > 0) {
                            return <div key={"summary_" + tab}>{tabSummary(tab)}</div>
                        } else {
                            return <></>;
                        }
                    }
                    )}
                    {tab < maximumResponse &&
                        <button className="add-new-child-response" onClick={() => setNewChild()}><FontAwesomeIcon className="add-icon" icon={faPlus} />Add {title}</button>
                    }


                    {isPopupOpen &&
                        <Popup
                            content={getPopupContent(tab)}
                            handleClose={togglePopup}
                            hideCloseButton={true}
                        />
                    }
                </>
            }
            {question.validationFail && question.answer === "1" && question.questionSetAnswerType.answerTypeName === "Boolean" &&
                <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> {"Please provide at least " + minimumResponse + " " + title.toLowerCase()}</div>
            }
            {question.validationFail && parseInt(answerText) > 0
                && (question.questionSetAnswerType.answerTypeName === "ListValueID" || question.questionSetAnswerType.answerTypeName === "RadioSelect")
                && !answerText.includes("+") &&
                <div className="validation-message question"><FontAwesomeIcon icon={faCircleExclamation} /> {"Please provide " + maximumResponse + " " + title.toLowerCase() + " records"}</div>
            }
            {question.validationFail && parseInt(answerText) > 0
                && (question.questionSetAnswerType.answerTypeName === "ListValueID" || question.questionSetAnswerType.answerTypeName === "RadioSelect")
                && answerText.includes("+") &&
                <div className="validation-message question"><FontAwesomeIcon icon={faCircleExclamation} /> {"Please provide at least " + minimumResponse + " " + title.toLowerCase() + " records"}</div>
            }
        </>

    )
}